import type { Category } from './supabase'
import type { CatalogEntry } from './catalog'
import { compareNames } from './locale'
import { matchItems } from './search'

// All items (components/list/AllItemsSheet): everything the household bought
// before and hasn't on the list now (lib/catalog.ts), to scroll through and
// add several at once. Grouped by aisle like the list, A–Z inside each so a
// name is easy to find by eye; what has no category (or lost it) comes last.

export interface BrowseGroup {
  /** null: no category, or one since deleted ("Other"). */
  category: Category | null
  entries: CatalogEntry[]
}

export function browseGroups(catalog: CatalogEntry[], categories: Category[], query: string, locale: string): BrowseGroup[] {
  const shown = query.trim() ? matchItems(catalog, query, locale, Infinity) : catalog
  const byId = new Map(categories.map(c => [c.id, c]))
  const buckets = new Map<string | null, CatalogEntry[]>()
  for (const e of shown) {
    const id = e.categoryId && byId.has(e.categoryId) ? e.categoryId : null
    buckets.set(id, [...(buckets.get(id) ?? []), e])
  }
  const cmp = compareNames(locale)
  const ordered = [...categories].sort((a, b) => a.sort_order - b.sort_order)
  return [...ordered.map(c => c.id), null]
    .filter(id => buckets.has(id))
    .map(id => ({
      category: id ? byId.get(id)! : null,
      entries: [...buckets.get(id)!].sort((a, b) => cmp(a.name, b.name)),
    }))
}
